import React, { useCallback, useState } from 'react';
import cx from 'classnames';
import Popover from 'react-tiny-popover';
import styles from './Sidebar.module.scss';

function SidebarLink(props) {
  const {
    component,
    className,
    icon,
    iconOnly,
    iconPosition,
    children,
    onMouseDown,
    active,
    showPopover,
    slim,
    mini,
    allowAnimation,
    onDark,
    customSidebarStyles,
    ...rest
  } = props;
  const buttonRef = React.useRef();

  const [isHover, setHover] = useState(false);
  const handleMouseEnter = useCallback(() => {
    if (!isHover) setHover(true);
  }, [isHover]);
  const handleMouseLeave = useCallback(() => {
    if (isHover) setHover(false);
  }, [isHover]);

  const handleMouseDown = useCallback(
    event => {
      if (onMouseDown) onMouseDown(event);
    },
    [onMouseDown]
  );

  let btnProps = {
    className: cx(className, styles.btn, styles.btn, {
      [styles.btnIconRight]: !!icon && iconPosition === 'right',
      [styles.btnIconOnly]: iconOnly,
      [styles.btnIconOnly]: iconOnly,
      // [styles.active]: active,
      [styles.slimLink]: slim,
      [styles.onDark]: onDark,
    }),
    onMouseDown: handleMouseDown,
    ...rest,
  };

  // eslint-disable-next-line no-nested-ternary
  const buttonText = Array.isArray(children)
    ? children.filter(child => typeof child === 'string').join(' ')
    : typeof children === 'string'
    ? children.toString()
    : null;

  let btnChildren = children;

  if (buttonText && !iconOnly) {
    btnProps = { 'aria-label': buttonText, ...btnProps };
    btnChildren = <span>{children}</span>;
  }

  if (iconOnly) btnChildren = null;

  let injectedIcon = icon;

  if (icon) {
    injectedIcon = React.cloneElement(icon, {
      className: cx(icon.props.className, styles.iconBtn),
    });
  }

  const buttonContent = (
    <>
      {iconPosition === 'right' ? btnChildren : injectedIcon}
      {iconPosition === 'right' ? injectedIcon : btnChildren}
    </>
  );

  return React.createElement(
    'div',
    {
      className: cx(
        styles.sidebarLink,
        { [styles.mini]: mini },
        { [styles.active]: active },
        { [styles.animate]: allowAnimation },
        customSidebarStyles
      ),
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
    },
    <Popover
      isOpen={showPopover && isHover}
      position="right" // preferred position
      content={<div className={styles.popoverContainer}>{buttonText}</div>}
      containerStyle={{ zIndex: '100' }}
    >
      {React.createElement(
        component,
        {
          ref: buttonRef,
          ...btnProps,
        },
        <>{buttonContent}</>
      )}
    </Popover>
  );
}

export default SidebarLink;
